import axios from "axios";

// function formatToTwoDecimalPlaces(value) {
//     let number = parseFloat(value);
//     return number % 1 === 0 ? number : number.toFixed(2);
// }
export async function fetchHumidityData(url) {
    try {
        const response = await axios.get(url);
        const raw = response?.data ?? {};
        let features = Array.isArray(raw.features) ? raw.features : [];
        if (features.length === 1 && Array.isArray(features[0])) {
            features = features[0];
        }
        const data = { type: 'FeatureCollection', ...raw, features };
        return { data, success: true };
    } catch (error) {
        console.log("Error", error);
        return { response: error.response, success: false };
    }
}



